// Libs
import Draggable from 'vuedraggable';
import Chart from 'chart.js';
import VueChartkick from 'vue-chartkick';
import fullCalendar from 'vue-fullcalendar';
import swatches from 'vue-swatches';
import VJsonschemaForm from '@koumoul/vuetify-jsonschema-form'
import { Sketch } from 'vue-color'
import JSONView from 'vue-json-component';
import vueJsonEditor from 'vue-json-editor';

// Libs styles
import 'vuetify/dist/vuetify.min.css';
import 'font-awesome/css/font-awesome.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'vue-swatches/dist/vue-swatches.min.css'
import '@koumoul/vjsf/dist/main.css'

// VJsf new
import VJsf from '@koumoul/vjsf';

// Forms
import JSONFormEditor from '../components/forms/JSONFormEditor';
import JSONSchemaForm from '../components/forms/JSONSchemaForm';

// Core Components
import Toolbar from '../components/core/Toolbar.vue';
import Navigation from '../components/core/NavigationDrawer.vue';
import Breadcrumbs from '../components/core/Breadcrumbs.vue';
import PageFooter from '../components/core/PageFooter.vue';

import Widget from '../components/Widget.vue';
import SocialWidget from '../components/SocialWidget.vue';
import DataTable from '../components/DataTable.vue';
import TimeLine from '../components/TimeLine.vue';
import UserTreeView from '../components/UserTreeView.vue';
import Stepper from '../components/Stepper.vue';

import LocationStatistic from '../components/statistics/LocationStatistic.vue';
import SiteViewStatistic from '../components/statistics/SiteViewStatistic.vue';
import TotalEarningsStatistic from '../components/statistics/TotalEarningsStatistic.vue';
import ConfirmModal from '../components/ConfirmModal';

// Import project styles
import '../styles/global.css';

/**
 * Set
 * @param Vue
 */
function setupComponents(Vue) {
  // Register plugins
  Vue.use(VueChartkick, { adapter: Chart });
  Vue.use(JSONView);

  // Register libs
  Vue.component('full-calendar', fullCalendar);
  Vue.component('swatches', swatches);
  Vue.component('color-picker', Sketch);
  Vue.component('VJsf', VJsf)
  Vue.component('VJsonschemaForm', VJsonschemaForm);
  Vue.component('draggable', Draggable);

  // Register core components
  Vue.component('toolbar', Toolbar);
  Vue.component('navigation', Navigation);
  Vue.component('breadcrumbs', Breadcrumbs);
  Vue.component('JsonFormEditor', JSONFormEditor);
  Vue.component('JsonSchemaForm', JSONSchemaForm);
  // Vue.component('page-footer', PageFooter);
  Vue.component('VJsonEditor', vueJsonEditor);
  Vue.component('widget', Widget);
  Vue.component('social-widget', SocialWidget);
  Vue.component('data-table', DataTable);
  Vue.component('time-line', TimeLine);
  Vue.component('user-tree-view', UserTreeView);
  Vue.component('stepper', Stepper);
  Vue.component('location-statistic', LocationStatistic);
  Vue.component('site-view-statistic', SiteViewStatistic);
  Vue.component('total-earnings-statistic', TotalEarningsStatistic);
  Vue.component('confirm-modal', ConfirmModal);
}

export {
  setupComponents
}



// WEBPACK FOOTER //
// ./src/config/setup-components.js